import { gql } from '@apollo/client';
import { prefillMessageWithGroupName } from 'utils/prefillMessageWithGroupName';
import { loadGQLUserGroupByCode } from 'groups/lib/GroupPromises';
import RemindAPI from 'lib/RemindAPI';
import { TARGET_TYPES } from 'entities/Message';
import type { Target } from 'entities/Message';

export async function getInitialAnnouncementTextForGroup(
  groupCode: string,
  target?: Target | null
): Promise<string> {
  const group = await loadGQLUserGroupByCode(groupCode);

  if (!group) {
    return '';
  }

  const groupUuid = group.uuid;
  const org = group.organization;
  const orgUuid = org ? org.uuid : '';
  const isOrganizationTarget = target ? target.type === TARGET_TYPES.ORGANIZATION_TARGET : false;
  const streamUuid = isOrganizationTarget ? orgUuid : groupUuid;

  const entityStreamIsEmpty = await RemindAPI.execute({
    query: gql`
      query getInitialAnnouncementTextForGroup($uuid: String!) {
        entityStreams(uuids: [$uuid]) {
          uuid
          sequenceItems {
            key
          }
        }
      }
    `,
    variables: { uuid: streamUuid },
    forceFetch: true,
  }).then(
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    (res) => res.entityStreams[0].sequenceItems.length === 0,
    (err) => {
      console.error('entityStreams query failure in getInitialAnnouncementTextForGroup');
      console.warn(err);
      return false;
    }
  );

  if (entityStreamIsEmpty) {
    return prefillMessageWithGroupName(group.className);
  }

  return '';
}
